<script lang="ts">
export type DotTone = 'neutral' | 'success' | 'warning' | 'danger' | 'online' | 'incall' | 'pause' | 'acw' | 'offline'
</script>

<script setup lang="ts">
/** Status dot. Always next to a text: a colour alone says nothing to a colour-blind user. */

withDefaults(defineProps<{ tone?: DotTone; live?: boolean }>(), { tone: 'neutral' })
const COLOR: Record<DotTone, string> = {
  neutral: 'bg-muted-foreground', success: 'bg-success', warning: 'bg-warning', danger: 'bg-danger',
  online: 'bg-agent-online', incall: 'bg-agent-incall', pause: 'bg-agent-pause', acw: 'bg-agent-acw',
  offline: 'bg-agent-offline',
}
</script>

<template>
  <!-- Live: a soft ring spreads from the dot (it rests when animations are reduced). -->
  <span aria-hidden="true" :class="[COLOR[tone], 'relative inline-block h-2 w-2 flex-none rounded-pill']">
    <span v-if="live" :class="[COLOR[tone], 'absolute inset-0 animate-ping-soft rounded-pill']" />
  </span>
</template>
